import * as React from "react";
import type { SVGProps } from "react";
const SvgPaymentCardSlashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.293 13.707a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.707.293A1 1 0 0 0 .293 1.707L1.48 2.894A4 4 0 0 0 0 6v8a4 4 0 0 0 4 4h12q.276 0 .548-.038l1.745 1.745a1 1 0 0 0 1.414-1.414zM14.586 16l-2.65-2.65A1 1 0 0 1 11 14H9a1 1 0 0 1 0-2h1.586l-3-3H2v5a2 2 0 0 0 2 2zm-9-9L2.909 4.324A2 2 0 0 0 2 6v1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18 7H9.414l2 2H18v5a2 2 0 0 1-.394 1.192l1.422 1.422A4 4 0 0 0 20 14V6a4 4 0 0 0-4-4H4.414l2 2H16a2 2 0 0 1 2 2z"
    />
  </svg>
);
export default SvgPaymentCardSlashed;
